import classNames from 'classnames';
import React, {ReactNode} from 'react';

import {MenuWidth} from './MenuConstants';

interface MenuPopoverProps {
  children: ReactNode;
  className?: string;
  dropLeft?: boolean;
  width?: MenuWidth;
}

function MenuPopover(props: MenuPopoverProps): JSX.Element {
  return (
    <div
      className={classNames(
        'menu',
        props.className,
        props.width && `menu--${props.width}Width`,
        props.dropLeft && 'menu--dropLeft'
      )}
    >
      {props.children}
    </div>
  );
}

export default MenuPopover;
